<template>
  <div>
    <v-form>
      <v-layout row="" wrap>

        <v-flex xs12 sm6 md6>
          <!-- <tarihcomp :etiket="'Fatura Tarihi'" :aktifmi="durum" v-bind:defaultvalue="'ok'" :tabindex="'50'"
            v-bind:value="val.FaturaBilgileri.FaturaTarihi" v-model="val.FaturaBilgileri.FaturaTarihi"></tarihcomp> -->
        </v-flex>

        <v-flex xs12 sm6 md6>
          <!-- <tarihcomp :etiket="'E-Arşiv Ödeme Tarihi'" v-model="val.FaturaBilgileri.EfaturaBilgileri.OdemeTarihi"
            v-bind:defaultvalue="'ok'" :tabindex="'51'" v-bind:value="val.FaturaBilgileri.EfaturaBilgileri.OdemeTarihi"></tarihcomp> -->
        </v-flex>

        <v-flex xs12 sm6 md6>
         <tarihcomp :etiket="$t('E-archive-Payment-Date')" :tabindex="'17'" v-bind:defaultvalue="'ok'"
                                    v-bind:value="val.FaturaBilgileri.EfaturaBilgileri.OdemeTarihi"
                                    v-model="val.FaturaBilgileri.EfaturaBilgileri.OdemeTarihi"></tarihcomp>
        </v-flex>

        <v-flex xs12 sm6 md6>
          <v-select :items="gonderimsekli" v-model="val.FaturaBilgileri.EfaturaBilgileri.GonderimSekli" tabindex="54"
            hide-details="" clearable item-text="text" item-value="value" :label="$t('E-archive-Delivery-Method')"></v-select>
        </v-flex>

        <v-flex xs12 sm6 md6>

          <v-select :items="odemesekli" tabindex="55" hide-details="" clearable item-text="text" item-value="value"
            v-model="val.FaturaBilgileri.EfaturaBilgileri.InternetSatis" :label="$t('E-archive-Internet-Sales')"></v-select>
        </v-flex>
        <v-flex xs12 sm6 md6>
          <webadresicomp :tabdeger="'56'" v-model="val.FaturaBilgileri.EfaturaBilgileri.WebAdresi"></webadresicomp>
        </v-flex>
        <v-flex xs12 sm6 md6>
          <v-select :items="odemesekli1" v-model="val.FaturaBilgileri.EfaturaBilgileri.OdemeSekli" tabindex="57"
            hide-details="" clearable item-text="text" item-value="value" :label="$t('E-archive-Payment-Method')"></v-select>
        </v-flex>
        <v-flex xs12 sm6 md6>
          <odemesekillericomp :tabdeger="'58'" v-model="val.FaturaBilgileri.EfaturaBilgileri.OdemeSekliAciklama">
          </odemesekillericomp>
        </v-flex>
        <v-flex xs12 sm6 md6>
          <odemearacicomp :tabdeger="'59'" v-model="val.FaturaBilgileri.EfaturaBilgileri.OdemeAraci"> </odemearacicomp>
        </v-flex>
        <v-flex xs12 sm6 md6>
          <v-text-field tabindex="60" v-model="val.FaturaBilgileri.KdvKod" hide-details="" :label="$t('VAT-Code')"></v-text-field>
        </v-flex>
        <v-flex xs12 sm6 md6>
          <v-text-field tabindex="61" v-model="val.FaturaBilgileri.IstinaKod" hide-details="" :label="$t('Exception-Code')"></v-text-field>
        </v-flex>

      </v-layout>
    </v-form>
  </div>
</template>

<script>
  import auth from '../../../../api/auth'
  import tarihcomp from '../../customcomp/tarihim'
  import webadresicomp from "@/components/app/bilet/partpage/webadresicomp.vue"
  import odemesekillericomp from "@/components/app/bilet/partpage/odemesekillericomp.vue"
  import odemearacicomp from "@/components/app/bilet/partpage/odemearacicomp.vue"



  export default {
    name: 'fatura',
    data() {
      return {
        doviztipi: [],
        efaturatipi: '',
        parainputdeger: 0,
        komisyontip: [{
          text: 'K-Komisyonlu',
          value: 'K'
        }, {
          text: 'P-Komisyonsuz',
          value: 'N'
        }],
        efaturatipi: [{
            text: this.$t('Commercial'),
            value: '0'
          },
          {
            text: this.$t('Basic'),
            value: '1'
          },
          {
            text: this.$t('Export'),
            value: '2'
          }
        ],
        gonderimsekli: [{
            text: this.$t('Paper'),
            value: 0
          },
          {
            text: this.$t('Electronic'),
            value: 1
          }
        ],
        odemesekli: [{
            text: this.$t('Normal-Sales'),
            value: 0
          },
          {
            text: this.$t('Internet-Sales'),
            value: 1
          }
        ],
        odemesekli1: [{
            text: this.$t('Credit-Debit-Card'),
            value: 0
          },
          {
            text: 'EFT-' + this.$t('Transfer-v3'),
            value: 1
          },
          {
            text: this.$t('Cash-on-delivery'),
            value: 2
          },
          {
            text: this.$t('Payment-Intermediary'),
            value: 3
          },
          {
            text: this.$t('Other'),
            value: 4
          }
        ],

        odemearaci: [],


      }
    },
    props: ['value', 'tabindex', 'name', 'id', 'durum', 'aktif', 'tabdeger'],
    computed: {
      val: {
        get: function () {

          return this.value;
        },
        set: function (newValue) {
          this.$emit('input', newValue)
        },
      }
    },
    beforeMount: beforeMount,
    components: {
      tarihcomp,
      webadresicomp,
      odemesekillericomp,
      odemearacicomp
    },

    methods: {
      faturadialogac() {
        var credentials = JSON.parse(window.localStorage.getItem('credentials'));
        this.faturadialog = true
        var params = {
          SirketKodu: credentials.SirketKodu,
          FaturaTip: 'D',
          DovizliFatura: false,
          HatTipi: this.Bilet.GenelBilgileri.UcusTipi
        }

        this.$http.post(auth.API_URL + 'api/TicketInvoice/InvoiceMainTableList', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.dizaynsec = response.body
        }, (response) => {
          if (response.status === 0) {
            this.progress = false
            this.text1 = 'Service Unavailable-InvoiceMainTableList'
            this.snackbar = true
          } else {
            this.text1 = 'Service Unavailable-InvoiceMainTableList'
            this.snackbar = true
          }
        })

        this.$http.post(auth.API_URL + 'api/TicketInvoice/InvoiceXsltTableList', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.xsltitems = response.body
        }, (response) => {
          if (response.status === 0) {
            this.progress = false
            this.text1 = 'Service Unavailable-InvoiceXsltTableList'
            this.snackbar = true
          } else {
            this.text1 = 'Service Unavailable-InvoiceXsltTableList'
            this.snackbar = true
          }
        })
      }

    },
  }

  function beforeMount() {


  }
</script>